import script from "./consolidated-payment-run-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./consolidated-payment-run-modal.vue?vue&type=script&setup=true&lang=ts"

import "./consolidated-payment-run-modal.vue?vue&type=style&index=0&id=2e1495bd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1495bd"]])

export default __exports__